import { createFileRoute, useNavigate, Link } from '@tanstack/react-router';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { pipelineService } from '@/features/pipeline/services/pipeline.service';
import { AssetForm } from '@/features/pipeline/components/AssetForm';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ArrowLeft } from 'lucide-react';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/pipeline/assets/$id')({
  component: EditAssetPage,
});

function EditAssetPage() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const qc = useQueryClient();

  const { data: asset, isLoading } = useQuery({
    queryKey: ['pipeline-asset', id],
    queryFn: () => pipelineService.getAsset(id),
  });

  const mutation = useMutation({
    mutationFn: (dto: any) => pipelineService.updateAsset(id, dto),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['pipeline-assets'] });
      qc.invalidateQueries({ queryKey: ['pipeline-asset', id] });
      toast.success('Asset atualizado!');
      navigate({ to: '/pipeline/assets' });
    },
    onError: () => toast.error('Erro ao atualizar asset'),
  });

  if (isLoading || !asset) return <div className="p-6 text-muted-foreground">Carregando...</div>;

  return (
    <PermissionGate permission={Permission.PIPELINE_MANAGE_ASSETS}>
      <div className="p-6 max-w-3xl mx-auto space-y-4">
        <Link
          to="/pipeline/assets"
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" /> Assets
        </Link>
        <Card>
          <CardHeader>
            <CardTitle>Editar asset</CardTitle>
          </CardHeader>
          <CardContent>
            <AssetForm
              defaultValues={asset}
              onSubmit={mutation.mutate}
              isLoading={mutation.isPending}
              submitLabel="Salvar alterações"
              onCancel={() => navigate({ to: '/pipeline/assets' })}
            />
          </CardContent>
        </Card>
      </div>
    </PermissionGate>
  );
}
